import customAxios from '../../customHook/customAxios';
import { getAuthHeader } from '../../utils';

export const v2_roles = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/roles`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_designations = async (roleId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/designations/${roleId}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_countries = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/country`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_states = async (country_id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/states/${country_id}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_state_districts = async (stateId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/districts/${stateId}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_ship_owners = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/shipOwner`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_yards = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/yards`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
export const v2_shipTypes = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/shipType`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_leaveTypes = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/leaveTypes`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_siteLocations = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/siteLocation`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_get_available_leave_types = async (gender) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/leaveType?gender=${gender}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_get_expense_types = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/expenseType`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_schedule_categories = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/schedule-category`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_categories = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/category`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v2_plan_type = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/planType`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v2_channels = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/channel`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_event_type = async (categoryId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/eventType?categoryId=${categoryId}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v2_document_type = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/documentType`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}




export const v2_shipyards = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/shipyards`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v2_companies = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/companies`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


